import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { GrainOverlay } from "@/components/GrainOverlay";
import { CookieBanner } from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import ChiSono from "@/pages/ChiSono";
import Servizi from "@/pages/Servizi";
import Editoriale from "@/pages/Editoriale";
import Contatti from "@/pages/Contatti";
import EditorialeDetail from "@/pages/EditorialeDetail";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
};

const Layout = () => {
  const location = useLocation();
  return (
    <>
      <Navbar />
      <main className="min-h-screen" key={location.pathname}><Outlet /></main>
      <Footer />
      <CookieBanner />
    </>
  );
};

function AppRouter() {
  return (
    <>
      <ScrollTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/chi-sono" element={<ChiSono />} />
          <Route path="/servizi" element={<Servizi />} />
          <Route path="/editoriale" element={<Editoriale />} />
          <Route path="/editoriale/:slug" element={<EditorialeDetail />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/privacy" element={<Legal kind="privacy" />} />
          <Route path="/cookie-policy" element={<Legal kind="cookie" />} />
          <Route path="/termini" element={<Legal kind="terms" />} />
        </Route>
        <Route path="/admin" element={<Admin />} />
        {/* Shop, login e area riservata temporaneamente disattivati (pagamenti/fiscalita/iubenda da definire) */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <GrainOverlay />
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
            <AppRouter />
            <Toaster position="bottom-right" />
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
